import { UpdatePackage } from "./UpdatePackage";

export class UpdatePackageInstallationsCount extends UpdatePackage {
    public targetInstallationsCount: number = 0;

    public parse(obj: any) {
        super.parse(obj);
        if (obj.TargetInstallationsCount) this.targetInstallationsCount = obj.TargetInstallationsCount;
    }
}
